import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';
import { InviteDto, UpdateInviteDto } from '@oracychampions/api-interfaces';

@Injectable({
  providedIn: 'root',
})
export class InvitesService {
  private http = inject(HttpClient);

  refresh$ = new BehaviorSubject(null);

  reloadInvites() {
    this.refresh$.next(null);
  }

  getInvites(schoolId: string | null): Observable<InviteDto[]> {
    return this.refresh$.pipe(
      switchMap(() =>
        schoolId
          ? this.http.get<InviteDto[]>(`${environment.API}/schools/${schoolId}/invites`)
          : this.http.get<InviteDto[]>(`${environment.API}/invites`),
      ),
    );
  }

  createInvite(invite: UpdateInviteDto): Observable<InviteDto[]> {
    return this.http.post<InviteDto[]>(`${environment.API}/invites`, invite);
  }

  updateInvite(id: string, invites: UpdateInviteDto): Observable<InviteDto[]> {
    return this.http.patch<InviteDto[]>(`${environment.API}/invites/${id}`, invites);
  }

  deleteInvite(id: string): Observable<any> {
    return this.http.delete<InviteDto[]>(`${environment.API}/invites/${id}`);
  }
}
